// extracted by mini-css-extract-plugin
export default {"rating":"CM-z","numberOfStars":"DM-z","count":"EM-z","barGraphSpacing":"FM-z","barGraph":"GM-z"};